(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["meta-add-to-cart-backup-20260818-165821"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__arkarMetaAddToCartBound) return;

    window.__arkarMetaAddToCartBound = true;

    let lastEventKey = '';
    let lastEventTime = 0;

    document.addEventListener('variant:added', (event) => {
      const item = event.detail?.variant;

      if (!item || typeof window.fbq !== 'function') return;

      const variantId = String(item.variant_id || item.id || '');
      const productId = String(item.product_id || '');

      if (!variantId) return;

      const quantity = Math.max(1, Number(item.quantity) || 1);
      const unitPriceCents = Number(item.final_price ?? item.discounted_price ?? item.price ?? 0);
      const lineValueCents = Number(item.final_line_price ?? unitPriceCents * quantity);
      const value = lineValueCents / 100;
      const currency = window.Shopify?.currency?.active || 'INR';
      const contentName = item.product_title || item.title || '';
      const eventKey = `${variantId}:${quantity}:${lineValueCents}`;
      const eventTime = Date.now();

      if (eventKey === lastEventKey && eventTime - lastEventTime < 1500) return;

      lastEventKey = eventKey;
      lastEventTime = eventTime;

      window.fbq('track', 'AddToCart', {
        content_ids: [variantId],
        content_name: contentName,
        content_type: 'product',
        contents: [
          {
            id: variantId,
            quantity,
            item_price: unitPriceCents / 100
          }
        ],
        currency,
        product_id: productId,
        quantity,
        value,
        variant_id: variantId
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meta-add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__arkarMetaAddToCartBound) return;

    window.__arkarMetaAddToCartBound = true;

    let lastEventKey = '';
    let lastEventTime = 0;

    const ensureMetaPixel = () => {
      if (typeof window.fbq === 'function') return window.fbq;

      const fbq = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
          return;
        }

        fbq.queue.push(arguments);
      };

      window.fbq = fbq;
      window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];

      const script = document.createElement('script');
      const firstScript = document.getElementsByTagName('script')[0];

      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      firstScript.parentNode.insertBefore(script, firstScript);
      fbq('init', '1091901493266211');

      return fbq;
    };

    document.addEventListener('variant:added', (event) => {
      const item = event.detail?.variant;

      if (!item) return;

      const variantId = String(item.variant_id || item.id || '');
      const productId = String(item.product_id || '');

      if (!variantId) return;

      const quantity = Math.max(1, Number(item.quantity) || 1);
      const unitPriceCents = Number(item.final_price ?? item.discounted_price ?? item.price ?? 0);
      const lineValueCents = Number(item.final_line_price ?? unitPriceCents * quantity);
      const value = lineValueCents / 100;
      const currency = window.Shopify?.currency?.active || 'INR';
      const contentName = item.product_title || item.title || '';
      const eventKey = `${variantId}:${quantity}:${lineValueCents}`;
      const eventTime = Date.now();

      if (eventKey === lastEventKey && eventTime - lastEventTime < 1500) return;

      lastEventKey = eventKey;
      lastEventTime = eventTime;

      ensureMetaPixel()('track', 'AddToCart', {
        content_ids: [variantId],
        content_name: contentName,
        content_type: 'product',
        contents: [
          {
            id: variantId,
            quantity,
            item_price: unitPriceCents / 100
          }
        ],
        currency,
        product_id: productId,
        quantity,
        value,
        variant_id: variantId
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
